import React from 'react';
import './style.scss';

export default function ColorInfo() {
  return (
    // <div className='colorInfoContainer my-5'>
    <div className='colorInfoContainer'>
      <span className='white'></span>
      <p className='ml-3'>میز آزاد</p>

      <span className='bg-success' ></span>
      <p className='ml-3'>میز رزرو شده</p>

      <span className='bg-warning'></span>
      <p className='ml-3'>در انتظار رزرو</p>

      <span className='bg-danger'></span>
      <p className='ml-3'>رزرو پایان یافته</p>

      <span className='bg-info'></span>
      <p>رزروهای با بیش از یک میز یا بیش از یک ساعت</p>

    </div>
  );
}
